"use strict";

/**
 * # Animation Au Scroll
 * Permet de faire apparaitre des éléments au scroll de cette façon. Exemple : 
```
    <div data-onscroll-fade> mon élement à faire apparaitre au scrol par un fade </div>
````

ou bien en faisant apparaitre 1 par 1 les éléments 
```
    <div data-onscroll-fade> 
        <ul>
        <li data-onscroll-fade-item> apparition 1</li>
        <li data-onscroll-fade-item> apparition 2</li>
        <li data-onscroll-fade-item> apparition 3</li>
        </ul>
    </div>
```

 */
class AnimateOnScroll {
  /**
   *
   * @param {HTMLElement} elements
   */
  constructor(element) {
    this.options = { threshold: [0.2, 0.55] };
    this.observer = "";
    this.element = element;

    this.items = this.element.querySelectorAll("[data-onscroll-fade-item]");

    this.keyframes = [
      {
        opacity: 0,
        transform: "translate(0,60px)",
      },
      {
        opacity: 1,
        transform: "translate(0,0)",
      },
    ];
  }

  anime() {
    this.observer = new IntersectionObserver(
      (e) => this.action(e),
      this.options
    );
    this.prepare();
    this.observer.observe(this.element);
  }

  prepare() {
    for (let key in this.keyframes[0]) {
      // un seul éléments
      if (this.items.length === 0) {
        this.element.style[key] = this.keyframes[0][key];
      } else {
        this.items.forEach(
          (item) => (item.style[key] = this.keyframes[0][key])
        );
      }
    }
  }

  action(e) {
    if (e[0].intersectionRatio > 0.2) {
      this.isVisible = true;

      // si un seul élement
      if (this.items.length === 0) {
        this.element.animate(this.keyframes, {
          duration: 1000,
          fill: "forwards",
          easing: "ease",
          delay: 300,
        });
      } else {
        this.items.forEach((item, index) => {
          item.animate(this.keyframes, {
            duration: 1000,
            fill: "forwards",
            easing: "ease",
            delay: index * 100,
          });
        });
      }

      // se joue qu'une fois
      this.observer.unobserve(this.element);
    }
  }

  static bind() {
    const elements = document.querySelectorAll("[data-onscroll-fade] > p, [data-onscroll-fade]");
    elements &&
      elements.forEach((element) => {
        const animation = new AnimateOnScroll(element);
        animation.anime();
      });
  }
}

window.onload = AnimateOnScroll.bind();
